import isGuestRoute from '@/auth/isGuestRoute';
import api from '../API';
import router from '../router';
// @ts-ignore
import AxiosErrorHandler from './AxiosErrorHandler';
import errorNotifier from './errorNotifier';

const handler = new AxiosErrorHandler(api);

export default function init() {
  handler.onAuthError(() => {
    if (!isGuestRoute(router.currentRoute.value.path)) {
      router.push('/login?redirect=true');
    }
  });
  handler.onError(errorNotifier);
}

export function handleVueError(e: Error) {
  errorNotifier({ code: e.message, message: e.message });
}
